import { render } from "./organisation-linking.vue?vue&type=template&id=5b8eb662&ts=true"
import script from "./organisation-linking.ts?vue&type=script&lang=ts&external"
export * from "./organisation-linking.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__